import { defineStore } from "pinia";

interface NavigationDrawerState {
    isOpen: boolean
}

export const useNavigationDrawerStore = defineStore('navigation-drawer', {
    state: (): NavigationDrawerState => ({
        isOpen: false
    }),

    getters: {

    },

    actions: {
        toggle() {
            this.isOpen = !this.isOpen
        },

        open() {
            this.isOpen = true
        },

        close() {
            this.isOpen = false
        }
    }
})